export default __webpack_public_path__ + "static/jen-ai-data-chats-banner-f47fe32eaad0544cd4820fe494bd7707.png";